<template>
  <el-row style="padding-top: 20px">
    <el-col :span="12" class="text-center">
      <div>设备总数</div>
      <div><span class="text-lightBlue" style="font-size: 2.4rem">{{ total }}</span>个</div>
    </el-col>
    <el-col :span="10" class="text-center">
      <div>设备告警</div>
      <div><span class="text-red" style="font-size: 2.4rem">{{ exception }}</span>个</div>
    </el-col>
  </el-row>
</template>

<script>
import {countDeviceStatusBySpaceAndTag} from "@/network/device-info";

export default {
  name: "SpaceDeviceTotal",
  props: ['currentSpaceInfo'],
  data() {
    return {
      normal: 0,
      exception: 0,
      total: 0,
    }
  },
  created() {
    if (this.currentSpaceInfo.id) {
      this.getData();
    }
  },
  watch: {
    currentSpaceInfo: {
      handler(val) {
        if (val.id) {
          this.getData();
        }
      }
    }
  },
  methods: {
    getData() {
      countDeviceStatusBySpaceAndTag(this.currentSpaceInfo.id).then(res => {
        if (res.code === 0) {
          this.total = 0;
          this.exception = 0;
          this.normal = 0;
          res.data.forEach(item => {
            this.total += item.value;
            if (item.name === 'exceptionCount') {
              this.exception = item.value;
            } else if (item.name === 'normalCount') {
              this.normal = item.value;
            }
          })
        }
      })
    }

  }
}
</script>

<style scoped>

</style>
